const DAY_MS = 86_400_000;

export function todayInSydney(now = new Date()) {
  const parts = new Intl.DateTimeFormat("en-AU", {
    timeZone: "Australia/Sydney",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(now);
  const values = Object.fromEntries(parts.map(({ type, value }) => [type, value]));
  return `${values.year}-${values.month}-${values.day}`;
}

function utcDay(dateString) {
  const [year, month, day] = dateString.split("-").map(Number);
  return Date.UTC(year, month - 1, day);
}

export function daysUntil(expiryDate, today = todayInSydney()) {
  if (!expiryDate) return null;
  return Math.round((utcDay(expiryDate) - utcDay(today)) / DAY_MS);
}

export function expiryBucket(expiryDate, today = todayInSydney()) {
  const days = daysUntil(expiryDate, today);
  if (days === null) return "none";
  if (days < 0) return "expired";
  if (days === 0) return "today";
  if (days <= 3) return "3-days";
  if (days <= 7) return "7-days";
  if (days <= 30) return "30-days";
  return "later";
}

export function matchesExpiryFilter(expiryDate, filter, today = todayInSydney()) {
  if (filter === "all") return true;
  const days = daysUntil(expiryDate, today);
  if (filter === "none") return days === null;
  if (days === null) return false;
  if (filter === "expired") return days < 0;
  if (filter === "today") return days === 0;
  if (filter === "3-days") return days >= 0 && days <= 3;
  if (filter === "7-days") return days >= 0 && days <= 7;
  if (filter === "30-days") return days >= 0 && days <= 30;
  return true;
}

export function expiryLabel(expiryDate, today = todayInSydney()) {
  const days = daysUntil(expiryDate, today);
  if (days === null) return "No expiry";
  if (days < -1) return `Expired ${Math.abs(days)} days ago`;
  if (days === -1) return "Expired yesterday";
  if (days === 0) return "Expires today";
  if (days === 1) return "Expires tomorrow";
  return `Expires in ${days} days`;
}

export function addDays(dateString, numberOfDays) {
  const date = new Date(utcDay(dateString) + numberOfDays * DAY_MS);
  return date.toISOString().slice(0, 10);
}
